import { a } from "../utils";

export const setSearchWord = (word: string) =>
    a({ type: "SET_SEARCHWORD", word });
